export const HighlightsData = [
    {
        id: 'all-posts',
        text: 'All My Posts',
        avatar: 'https://e-huynh.github.io/updated_portfolio/assets/About_me.JPG',
        filterBy: ''
    },
    {
        id: 'about-me',
        text: 'About Myself',
        avatar: 'https://e-huynh.github.io/updated_portfolio/assets/About_me.JPG',
        filterBy: 'bio'
    },
    {
        id: 'projects',
        text: "Projects",
        avatar: 'https://e-huynh.github.io/updated_portfolio/assets/About_me.JPG',
        filterBy: 'project'
    },
]